export default __webpack_public_path__ + "static/media/jeringa.7acf68d8.png";